import {Injectable} from '@angular/core';
import {Sort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';

@Injectable({
    providedIn: 'root'
})
export class HelperService {

    constructor() {
    }

  createStoreRequest(action: string, body: Object) {
    let auth: any = localStorage.getItem('auth');
    auth !== 'undefined' ?
      auth = JSON.parse(localStorage.getItem('auth')) :
      auth = null;
    return {
      'action': action,
      'clientName': 'safe-home',
      'data': body,
      'token': auth ? auth.token : null
    };
  }

  sleep = (milliseconds) => new Promise(resolve => setTimeout(resolve, milliseconds));

  async asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array);
    }
  }


  sortData(sort: Sort, data) {

    if (typeof data !== 'object') {
      return;
    }

    const compare = (a: number | string, b: number | string, isAsc: boolean) => {
      a = a ? a : '';
      b = b ? b : '';
      return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    };
    if (!sort.active || sort.direction === '') {
      return;
    }
    data = data.sort((a, b) => {
        const isAsc = sort.direction === 'asc';
        // For table columns which need to be sorted more specifically according to a 'value' property differing to
        // the one displayed in the table
        // Ex: dates with formatted display (sorted on timestamp), values with units...
        const valueA = typeof a[sort.active] === 'object' ? a[sort.active].value : a[sort.active];
        const valueB = typeof b[sort.active] === 'object' ? b[sort.active].value : b[sort.active];
        return compare(valueA, valueB, isAsc);
      }
    );
    return new MatTableDataSource(data);
  }

  static imageByType(type: any) {
    if (type !== undefined) {
      if (type === 'liris_v2' || type === 'liris_v3' || type === 'ext_v3') {
        return 'liris';

      } else if (type === 'inclino_v2' || type === 'inclino_v3' || type === 'inclinobiaxis_v2') {
        return 'tilt';

      } else if (type === 'optic_v5') {
        return 'wiredSensor';

      } else if (type === 'pt_v5') {
        return 'wiredSensor';
      } else {
        return 'wiredSensor';
      }
    }
  }

  public getColor(unit: string, locationkeyid: number): string {
    let colorHexa: string;
    if (unit === 'TEMPERATURE') {
      colorHexa = this.getGreyOrColorsHex(false, locationkeyid);
    } else if (unit === 'RADIAN-Y') {
      colorHexa = this.getGreyOrColorsHex(true, locationkeyid * 4);
    } else {
      colorHexa = this.getGreyOrColorsHex(true, locationkeyid);
    }
    return colorHexa;
  }

  public getGreyOrColorsHex(isColor: boolean = true, locationId: number): string {

    const colors: string[] = isColor === true ? this.colorLib() : this.greyLib();
    const index = Math.abs(Number(locationId.toString().slice(-2)) % colors.length);
    return colors[index];
  }

  private greyLib(): string[] {
    return [
      '#b1b2d5',
      '#9dabba',
      '#9396ab',
      '#7f8095',
      '#696d7c',
      '#585861',
      '#4a484e',
      '#353236',
      '#1c1b1c',
      '#000000'
    ].reverse();
  }

  private colorLib(): string[] {
    return [
      '#3366CC',
      '#DC3912',
      '#FF9900',
      '#109618',
      '#990099',
      '#3B3EAC',
      '#0099C6',
      '#DD4477',
      '#66AA00',
      '#B82E2E',
      '#316395',
      '#994499',
      '#22AA99',
      '#AAAA11',
      '#6633CC',
      '#E67300',
      '#8B0707',
      '#329262',
      '#5574A6',
      '#3B3EAC',
    ];
  }


}



